import { render } from "./gkDashboardView.vue?vue&type=template&id=b640e43e"
import script from "./gkDashboardView.vue?vue&type=script&lang=js"
export * from "./gkDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__